export function getRootFontSize() {
    return parseFloat(getComputedStyle(document.documentElement).fontSize) || 16;
}

export function pxToRem(px) {
    return px / getRootFontSize();
}

export function pxToRemUnit(px) {
    return `${pxToRem(px)}rem`;
}

export default pxToRem;
